import {Chip, ColorPaletteProp, IconButton, Stack, Typography} from "@mui/joy";
import React from "react";
import {ChevronLeft, ChevronRight} from "lucide-react";
import {usePagination} from "../hooks/usePagination";

type PaginationComponentProps = {
    pageCount: number,
    color?: ColorPaletteProp
}

const PaginationComponent = (props: PaginationComponentProps) => {
    const pages = []
    const pagination = usePagination()
    // One page (or none) has nothing to paginate.
    if (!(props.pageCount > 1))
        return null

    for (let i = 0; i < props.pageCount; i++)
        pages.push(i + 1)

    return <Stack gap={1} direction={'row'} justifyContent={"center"} alignItems={"center"} width={"100%"} paddingY={2}>
        <IconButton onClick={pagination.onPreviousPage} disabled={pagination.currentPage === 1} size={"sm"}
                    sx={{borderRadius: 20}}>
            <ChevronLeft/>
        </IconButton>

        {props.pageCount > 10 ?
            <>
                {pages.map((page, index) => (index < pagination.currentPage + 2 && index > pagination.currentPage - 3) &&
                    <Chip size={"lg"} color={props.color || "primary"}
                          onClick={pagination.currentPage === page ? null : () => pagination.onSelectPage(page)}
                          variant={pagination.currentPage === page ? "soft" : "plain"}
                          sx={{borderRadius: 20, paddingX: 1.7, paddingY: 0.5, fontSize: 20}}>
                        {page}
                    </Chip>)}

                {(pagination.currentPage + 2 < props.pageCount - 3) &&
                    <Typography color={props.color || "primary"} level={"title-md"}>
                        ...
                    </Typography>}

                {pages.map((page, index) => ((index >= props.pageCount - 3 && index + 1 > pagination.currentPage + 2)) &&
                    <Chip size={"lg"} color={props.color || "primary"}
                          onClick={pagination.currentPage === page ? null : () => pagination.onSelectPage(page)}
                          variant={pagination.currentPage === page ? "soft" : "plain"}
                          sx={{borderRadius: 20, paddingX: 1.7, paddingY: 0.5, fontSize: 20}}>
                        {page}
                    </Chip>)}
            </> :
            pages.map(page =>
                <Chip size={"lg"} color={props.color || "primary"}
                      onClick={pagination.currentPage === page ? null : () => pagination.onSelectPage(page)}
                      variant={pagination.currentPage === page ? "soft" : "plain"}
                      sx={{borderRadius: 20, paddingX: 1.7, paddingY: 0.5, fontSize: 20}}>
                    {page}
                </Chip>)}

        <IconButton onClick={pagination.onNextPage} disabled={pagination.currentPage === pages.length} size={"sm"}
                    sx={{borderRadius: 20}}>
            <ChevronRight/>
        </IconButton>
    </Stack>
}


export default PaginationComponent